import { replaceToUmlauts } from "~/mixins/formatting";
import { translateStateName } from "~/mixins/translations";

const CITY_STATES = ["Bremen", "Berlin", "Hamburg"];

export const isCityState = (category: string): boolean => {
  return CITY_STATES.includes(translateStateName(replaceToUmlauts(category)));
};
